import type { InventoryFilters } from '@/lib/api/client/inventory'

// Paging, ordering and facet requests shape a page; they never select pieces.
const NOT_SELECTORS = new Set<string>(['include', 'sort', 'direction', 'limit', 'offset'])

/**
 * The whole «Выбрать все по фильтру» filter as the server resolves it.
 * Every selector is sent; the server resolves all of them or refuses.
 */
export function selectionFilterBody(filter: InventoryFilters): Record<string, unknown> {
  const body: Record<string, unknown> = {}
  for (const [key, value] of Object.entries(filter)) {
    if (value === undefined || value === false || NOT_SELECTORS.has(key)) continue
    if (Array.isArray(value) && value.length === 0) continue
    body[key] = value
  }
  return body
}
